module.exports = __webpack_public_path__ + "static/media/cube.2ce9a9e7.svg";